module.exports = __webpack_public_path__ + "static/media/icon_k.d3e683ac.svg";